import './styles.scss'

import React from 'react'

import PropTypes from 'prop-types'

import starIcon from '../_assets/star-icon.svg'

const ReviewLine = ({ reviewText, reviewCount, reviewSum, averageRating, withParentheses }) => {
  return (
    <div className='reviews-container'>
      <div className='reviews-stars'>
        <img className='star-icon' alt='star icon' src={starIcon} width={19} height={19} />
        <div className='average-reviews'>{averageRating || Math.ceil((reviewSum / reviewCount) * 10) / 10}</div>
      </div>
      <div className='reviews-number-container'>
        <a className='reviews-number' href={`#reviews`}>
          {withParentheses ? `(${reviewText || reviewCount})` : `${reviewText || reviewCount}`}
        </a>
      </div>
    </div>
  )
}

export default ReviewLine

ReviewLine.propTypes = {
  reviewText: PropTypes.string,
  averageRating: PropTypes.string,
  reviewCount: PropTypes.number,
  reviewSum: PropTypes.number,
  withParentheses: PropTypes.bool
}
